import React, { useCallback, useMemo } from 'react';
import InputField from './InputField';
import { trackEvent } from '../lib/analytics';

function AddressFields({ address, setAddress, data, onUserChangedAddressColumns = () => {} }) {
  // We define a stable callback for changing address columns
  const handleAddressChange = useCallback(
    (field) => (e) => {
      setAddress((prev) => ({
        ...prev,
        [field]: {
          index: data[0]?.indexOf(e.target.value) ?? null,
          value: e.target.value,
        },
      }));
      // Track user column override
      trackEvent('address.mapping.changed', {
        field,
        newColumn: e.target.value,
      });
      onUserChangedAddressColumns();
    },
    [data, setAddress, onUserChangedAddressColumns]
  );

  // Memoize header row so it's not a new array each render
  const headerOptions = useMemo(() => data[0] || [], [data]);

  const requiredFields = ['street', 'city', 'state', 'zip'];
  const allSelected = requiredFields.every((field) => address[field].value);

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {requiredFields.map((field) => (
          <InputField
            key={field}
            label={`${field.charAt(0).toUpperCase() + field.slice(1)} Column`}
            value={address[field].value}
            onChange={handleAddressChange(field)}
            options={headerOptions}
            hasError={!address[field].value}
            required
          />
        ))}
      </div>
      {!allSelected && (
        <p className="text-red-400 text-sm">
          All columns are required for accurate address processing
        </p>
      )}
    </div>
  );
}

export default AddressFields;
